import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`

export const Image = styled.img`
  width: 104px;
  height: 104px;
  aspect-ratio: 1/1;
`

export const Text = styled.div`
  ${Typography.Subhead}
  text-align: center;

  ${Media.Tablet`
    width: 466px;
  `}

  ${Media.Phone`
    width: 261px;
  `}
`

export const Progress = styled.progress`
  width: 240px;
  height: 4px;
  border-radius: 2px;
  border: none;
  background-color: ${Colors.Neutral10};
  margin-top: 24px;

  &::-webkit-progress-bar {
    background-color: ${Colors.Neutral10};
    border-radius: 10px;
  }

  &::-webkit-progress-value {
    background-color: ${Colors.Blue50};
    border-radius: 10px;
    transition: width 0.5s ease-in-out;
  }

  &::-moz-progress-bar {
    background-color: ${Colors.Blue50};
    border-radius: 10px;
    transition: width 0.5s ease-in-out;
  }

  ${Media.Phone`
    margin-top: 16px;
  `}
`
